import React from 'react';
import { COLORS } from '../utils/constants';

/**
 * Top-level error boundary that prevents the entire app from unmounting
 * when an unhandled render-time exception occurs.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console in all environments; swap for Sentry/LogRocket in production
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.icon}>⚠️</div>
          <h1 style={styles.title}>Algo deu errado</h1>
          <p style={styles.message}>
            Ocorreu um erro inesperado no aplicativo. Por favor, recarregue a página para continuar.
          </p>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={styles.detail}>{this.state.error.toString()}</pre>
          )}
          <button style={styles.button} onClick={this.handleReload}>
            Recarregar página
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0a0e1a 0%, #1a2035 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  card: {
    backgroundColor: COLORS.backgroundCard,
    borderRadius: 16,
    padding: 32,
    width: '100%',
    maxWidth: 400,
    textAlign: 'center',
    border: `1px solid ${COLORS.border}`,
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
  },
  icon: {
    fontSize: 56,
    marginBottom: 16,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: COLORS.text,
    margin: '0 0 12px 0',
  },
  message: {
    fontSize: 14,
    color: COLORS.textSecondary,
    lineHeight: 1.6,
    margin: '0 0 24px 0',
  },
  detail: {
    backgroundColor: 'rgba(239,68,68,0.08)',
    border: `1px solid rgba(239,68,68,0.3)`,
    borderRadius: 8,
    padding: 12,
    fontSize: 12,
    color: COLORS.danger,
    textAlign: 'left',
    overflowX: 'auto',
    marginBottom: 20,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  button: {
    backgroundColor: COLORS.primary,
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '12px 24px',
    fontSize: 15,
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
  },
};

export default ErrorBoundary;
